import { CvDatabaseAccessTokenRequestStatus } from './cv-database-access-token-request-status';
import { Serializable } from '../../../core/models/serializable';
import { RangeFilter } from '@admin/shared/models/range.model';
export class CvDatabaseAccessTokenRequestFilterModel
  implements Serializable<CvDatabaseAccessTokenRequestFilterModel>
{
  fromObject(object: any): CvDatabaseAccessTokenRequestFilterModel {
    throw new Error('Method not implemented.');
  }
  toObject() {
    let result = {
      CustomerName: this.customerName,
      StatusIds: this.statusIds,
    };

    return result;
  }

  public customerName: string;
  public statusIds: CvDatabaseAccessTokenRequestStatus[];

  constructor() {
    this.statusIds = [];
  }
}
